import {TEMPORARY_PROPERTY, ACTION_POINT, ACTION_LINE, ACTION_POLYGON, ACTION_CIRCLE, ACTION_TEXT} from './AnnotationConstants';
import GlobalMixin from '@/app/shared/mixins/global';
import {createEmpty as createEmptyExtent, isEmpty as isEmptyExtent, createOrUpdateFromCoordinates} from 'ol/extent';
import Collection from 'ol/Collection';
import { isArray, isObject } from '@config/utils';
import { v1 as uuidv1 } from 'uuid';

let vars = {
    drawFeatures: new Collection(),
    source: null,
    layer: null,
};

export default {
    mixins: [
        GlobalMixin,
    ],
    props: {
    },
    data() {
        return {
            temporaryProperty: TEMPORARY_PROPERTY,
        }
    },
    computed: {
        configMap() {
            return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getConfigMap`] : {};
        },
        layersProperties() {
            return this.configMap.layers ? this.configMap.layers.annotations : {};
        },
        sourceId() {
            return this.layersProperties.source;
        },
        layerId() {
            return this.layersProperties.layer;
        },
        zoomToBoundsDuration() {
            return this.layersProperties.duration || 1000;
        },
        zoomToBoundsScale() {
            return this.layersProperties.zoomScale || 1;
        },
        drawControls() {
            return {
                point: {
                    type: ACTION_POINT.type,
                    geometryType: ACTION_POINT.geometryType,
                    title: ACTION_POINT.title,
                    icon: null,
                    img: this.assetsPathTheme('/map/draw-point-24.png'),
                    active: true,
                },
                line: {
                    type: ACTION_LINE.type,
                    geometryType: ACTION_LINE.geometryType,
                    title: ACTION_LINE.title,
                    icon: null,
                    img: this.assetsPathTheme('/map/draw-polyline-24.png'),
                    active: true,
                },
                polygon: {
                    type: ACTION_POLYGON.type,
                    geometryType: ACTION_POLYGON.geometryType,
                    title: ACTION_POLYGON.title,
                    icon: null,
                    img: this.assetsPathTheme('/map/draw-polygon-24.png'),
                    active: true,
                },
                circle: {
                    type: ACTION_CIRCLE.type,
                    geometryType: ACTION_CIRCLE.geometryType,
                    title: ACTION_CIRCLE.title,
                    icon: null,
                    img: this.assetsPathTheme('/map/draw-circle-24.png'),
                    active: false,
                },
            }
        },
        activeDrawControls() {
            const filtered = Object.entries(this.drawControls).filter(([key, value]) => value.active);
            return Object.fromEntries(filtered);
        },
    },
    methods: {
        features() {
            return vars.drawFeatures;
        },
        hasFeatures() {
            return this.features().getLength() > 0;
        },
        generateId: function() {
            return uuidv1();
        },
        /**
	     * Method: createCRSObject
	     * Create the CRS object for an object.
	     *
	     * Parameters:
	     * object - {<ol.proj.Projection>}
	     *
	     * Returns:
	     * {Object} An object which can be assigned to the crs property
	     * of a GeoJSON object.
	     */
	    createCRSObject: function(proj) {
            proj = isObject(proj) ? proj.getCode() : proj;
	        let crs = {};
	        if (proj.match(/epsg:/i)) {
	           var code = parseInt(proj.substring(proj.indexOf(":") + 1));
	           if (code == 4326) {
	               crs = {
	                   "type": "name",
	                   "properties": {
	                       "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
	                   }
	               };
	           } else {
	               crs = {
	                   "type": "name",
	                   "properties": {
	                       "name": "urn:ogc:def:crs:EPSG::" + code
	                   }
	               };
	           }
	       }
	       return crs;
	    },
        resetDrawFeatures: function() {
            vars.drawFeatures.clear();
        },
        getFeaturesExtent: function(features) {
            let extent = createEmptyExtent();
            if(features) {
                let coordinates = [];
                features.forEach(feat => {
                    let coords = feat.geometry.coordinates;
                    if(isArray(coords[0]) && coords[0].length > 2) {    //poligonos
                        coordinates = [...coordinates, ...coords[0]];
                    }else if(isArray(coords[0])) {  // linhas
                        coordinates.push(...coords);
                    }else{
                        coordinates.push([...coords]);
                    }
                    // extent = extendExtent(extent, feat.getGeometry().getExtent());
                });
                createOrUpdateFromCoordinates(coordinates, extent);
            }
            return isEmptyExtent(extent) ? null : extent;
        },
        setMapLayer: function(remove=false) {
            const _map = this.map;
            if(!_map)
                return;

            const optionsLayer = this.layersProperties;
            let sourceId = this.sourceId;
            let layerId = this.layerId;
            let _source = _map.getSource(sourceId);
            let _layer = _map.getLayer(layerId);
            if(remove) {
                this.resetDrawFeatures();
                let _source = _map.getSource(sourceId);
                if(_source){
                    _map.clearSource(sourceId);
                }
                let _layer = _map.getLayer(layerId);
                if(_layer){
                    _map.removeLayer(_layer);
                }
                _map.setLayer(layerId, null);
                _map.setSource(sourceId, null);
            }else{
                if(!_layer){
                    if(!_source){
                        _source = _map.createVectorSource({
                            features: vars.drawFeatures,
                        });
                        _map.setSource(sourceId, _source);
                    }
                    let zIndex = Math.max(Math.max(..._map.getLayers().getArray().map(o => o.getZIndex())) + 1, optionsLayer.zindex);
                    _layer = _map.createVectorLayer({
                        source: _source,
                        zIndex: zIndex,
                        style: this.styleFeature(),
                    });
                    _map.setLayer(layerId, _layer);
                    _map.addlayerToMap({layer: _layer});

                }
                _map.clearSource(sourceId);
            }
            vars.source = _source;
            vars.layer = _layer;
        },
        // the style function for the feature overlay returns
        // a text style for point features and the highlight
        // style for other features (polygons in this case)
        // styleFunction: function(feature, resolution) {
        //     console.log('feature---', feature.getProperties());
        //     if(feature) {
        //         let highlight = !!feature.get('highlight');
        //         console.log('highlight---', highlight);
        //         let style = highlight ? this.highlightStyleFeature() : this.styleFeature();
        //         return [style];
        //     }
        //     return [];
        // },
        styleFeature: function() {
            const _map = this.map;
            if(_map){
                return _map.createStyle({
                    fill: {
                        color: 'rgba(255, 255, 255, 0.2)',
                    },
                    stroke: {
                        color: '#ffcc33',
                        width: 3,
                        lineCap:'square',
                        lineJoin:'round',
                    },
                    circle: {
                        radius: 6,
                        stroke: {
                            color: '#ffcc33',
                        },
                        fill: {
                            color: '#ffcc33'
                        },
                    },
                });
            }
            return null;
        },
        highlightStyleFeature: function() {
            const _map = this.map;
            if(_map){
                return _map.createStyle({
                    fill: {
                        color: 'rgba(255, 255, 255, 0.2)',
                    },
                    stroke: {
                        color: '#3399CC',
                        width: 4,
                        lineCap:'square',
                        lineJoin:'round',
                    },
                    circle: {
                        radius: 6,
                        stroke: {
                            color: '#3399CC',
                            width: 2.5
                        },
                        fill: {
                            color: 'rgba(255,255,255,0.4)'
                        },
                    },
                });
            }
            return null;
        },
    },
}